/**
 * List of presentational query string parameters that are available on any page.
 * @name Presentation URL Parameters
 * @query showHeaderOnlyOnMobile {String} Values: '1'. Hides the header and the menu on desktop and balances on mobile.
 * @query noPageAsPopup {String} Values: '1'. Forces the page to be displayed as a regular page, even if it is configured to be displayed as a popup in CMS.
 * @query hideNav {String} Values: '1'. Hides the side navigation.
 * @query hideHeader {String} Values: '1'. Parameters that hides header from the page.
 * @query hideFooter {String} Values: '1'. Parameters that hides footer from the page.
 * @query hideChat {String} Values: '1'. Do not initialize Playtech Chat widget on the page.
 * @query hideInbox {String} Values: '1'. Do not initialize Playtech Inbox widget on the page.
 * @query hideKYC {String} Values: '1'. Do not show verification popup (e.g. Jumio) on page load.
 * @query hideCookieLayer {String} Values: '1'. Do not show cookie regulation message on page load.
 * @query hideAdminControls {String} Values: '1'. If accessed as CMS administrator, hide any admin controls.
 * @query emulate {String} Values: 'mobile', 'tablet'. Only works with ?hideAdminControls=1. Parameters that emulates rendering of the page as if opened in another form factor.
 * @query showTranslationKeys {String} Values: '1'. parameters that shows translations keys instead of actual messages whenever applicable.
 * @query back_url {String} URL to redirect after back button click.
 * @query disableMessageSubscriptions {String} Values: 'alert', 'bonus', 'bonus:2', 'rg-timer', 'rg-panic', 'rg:realitycheck', 'hurl', 'quick-deposit', 'dg', 'avatar', 'advanced-dialog', 'advanced-dialog-lobby'. Portal will be subscribed to session actions from CMS except pointed here actions.
 * @query themeName {String} If non-candy-theme exist in CMS it will be applied.
 * @example https://www.example.com/?hideHeader=1
 * @example https://www.example.com/?showTranslationKeys=1
 * @example https://www.example.com/?hideAdminControls=1&emulate=mobile
 */

/**
 * List of authentication query string parameters that are available on any page.
 * @name Authentication URL Parameters
 * @query username {String} Player's username to perform login with.
 * @query temptoken {String} IMS temporary token to perform login with.
 * @query login_action {String} If used on the page where login form is presented, player is being navigated to the page specified in the parameter when successfully logged in.
 * @query afterLoginUrl {String} URL to redirect after login flow, but will disappear on login popup initialize.
 * @example https://www.example.com/?username=test_player&temptoken=s-t-xyz...
 * @example https://www.example.com/?login_action=/another-page
 */

/**
 * List of integration query string parameters that are available on any page.
 * @name Integration URL Parameters
 * @query clientPlatform {String} Specifies client platform for the session. It is used in authentication and game-related operations. Values: 'ivr', 'smsbetting', 'retailotc', 'download', 'retailbip', 'telebet', 'flash', 'oncourse', 'retailterminal', 'system', 'admin', 'web', 'mobile', 'desktop'.
 * @query clientVersion {String} Overrides the client version for the session.
 * @query clientType {String} Overrides the client type for the session. Values: 'casino', 'poker', 'bingo', 'sportsbook'.
 * @query clientSkin {String} Overrides the client skin for the session.
 * @query deliveryPlatform=Hub2 {String} Specifies delivery platform for the session. It is used in authentication and game-related operations.
 * @query isNative {String} Values: '1'. Used to enable Native App and Biometrics integration. Usually is used in URL templates that configure native application to open registration and login pages.
 * @query htcmd  {String} Values: '1'. Used to enable Download Client integration. Usually is used in URL templates that configure links for Download Clients to open registration and login pages.
 */

/**
 * List of affiliate query string parameters that are available on any page.
 * The following list of parameters is responsible for creating banner_domainclick cookie.<br />
 * If at least one of the parameters is passed – the cookie is created.<br />
 * Omitted parameters are passed as empty values.<br />
 * Cookie is created for base domain, root directory and without expiration time (session cookie) in the following format:<br />
 * <code>document.cookie='banner_domainclick=advertiser;bannerid;profileid;refererurl;creferer'</code>
 * @name Affiliate URL Parameters
 * @query advertiser {String}
 * @query bannerid {String}
 * @query profileid {String}
 * @query refererurl {String}
 * @query creferer {String}
 */

/**
 * List of miscellaneous query string parameters that are available on any page.
 * @name Miscellaneous URL Parameters
 * @query promocode {String} Promotional code that is being automatically inserted into Registration form or in Cahshier-related forms if corresponding field exists there.
 * @query real {String} Values: '1', '0'. Selects mode to launch the game in. Should be used as ?real=1 or ?real=0 on /igaming/<gameCode>/ routes only.
 */

export { usePublicApi } from './usePublicAPI';
